module.exports = __webpack_public_path__ + "static/media/line.22e5a498.svg";